/** Figma chat column — fixed max width; mx-auto keeps left/right margin equal. */
export const CHAT_COLUMN_MAX_WIDTH_PX = 681;

/**
 * Shared width for main chat transcript + input so bubbles align with the composer.
 * Keep in sync with {@link src/pages/chat/chat.tsx} input shell.
 */
export const CHAT_MAIN_COLUMN_CLASS = 'mx-auto w-full min-w-0 max-w-[681px]';

/** Horizontal inset for chat column — applied on the shell so max-width content stays full width inside. */
export const CHAT_COLUMN_INSET_CLASS = 'px-4 sm:px-6 md:px-8 xl:px-0';

/** Outer shell: horizontal padding from the main panel edges. */
export const CHAT_COLUMN_SHELL_CLASS = `w-full min-w-0 ${CHAT_COLUMN_INSET_CLASS}`;

/** Empty-chat landing inner column (no extra inset — padding lives on the shell). */
export const CHAT_LANDING_COLUMN_CLASS = CHAT_MAIN_COLUMN_CLASS;

/** Figma chat composer yellow ambient shadow */
export const CHAT_INPUT_YELLOW_SHADOW_CLASS =
  'shadow-[0px_2px_8px_0px_rgba(249,255,46,0.17)] dark:shadow-md';

/** Full-page chat scroll: thin thumb at the viewport right edge, transparent track. */
export const CHAT_MESSAGES_SCROLL_CLASS =
  'overflow-y-auto overscroll-contain [scrollbar-gutter:stable] [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-border/70 hover:[&::-webkit-scrollbar-thumb]:bg-border dark:[&::-webkit-scrollbar-thumb]:bg-muted-foreground/35 dark:hover:[&::-webkit-scrollbar-thumb]:bg-muted-foreground/50';

/** Sidebar nested lists (e.g. Hermes-Agent nav): thin dot thumb, no fat global scrollbar. */
export const SIDEBAR_INNER_SCROLL_CLASS =
  'overflow-y-auto overflow-x-hidden overscroll-contain [scrollbar-width:thin] [scrollbar-color:hsl(var(--border)/0.65)_transparent] [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar]:h-1.5 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:min-h-8 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-border/70 hover:[&::-webkit-scrollbar-thumb]:bg-border dark:[&::-webkit-scrollbar-thumb]:bg-muted-foreground/40 dark:hover:[&::-webkit-scrollbar-thumb]:bg-muted-foreground/55';

/** Figma message bubble action icons (copy, feedback, play, regenerate, info). */
export const CHAT_MESSAGE_ACTION_ICON_SIZE = 20;
export const CHAT_MESSAGE_ACTION_ICON_STROKE = 1.5;
/** Slightly smaller — RefreshDouble / InfoCircle artwork reads larger at 20px. */
export const CHAT_MESSAGE_ACTION_ICON_COMPACT_SIZE = 17;
export const CHAT_MESSAGE_ACTION_ICON_CLASS = 'shrink-0 aspect-square text-[#B0B0B0]';

export const CHAT_MESSAGE_ACTION_ICON_PROPS = {
  width: CHAT_MESSAGE_ACTION_ICON_SIZE,
  height: CHAT_MESSAGE_ACTION_ICON_SIZE,
  strokeWidth: CHAT_MESSAGE_ACTION_ICON_STROKE,
  className: CHAT_MESSAGE_ACTION_ICON_CLASS,
} as const;

export const CHAT_MESSAGE_ACTION_ICON_COMPACT_PROPS = {
  width: CHAT_MESSAGE_ACTION_ICON_COMPACT_SIZE,
  height: CHAT_MESSAGE_ACTION_ICON_COMPACT_SIZE,
  strokeWidth: CHAT_MESSAGE_ACTION_ICON_STROKE,
  className: CHAT_MESSAGE_ACTION_ICON_CLASS,
} as const;
